// extracted by mini-css-extract-plugin
export default {"wrapper":"dU-z","availablePromoMessagesLabel":"eU-z","promoMessageList":"fU-z","promoMessage":"gU-z","appliedPromoMessage":"hU-z","promoMessageAmount":"iU-z"};